import { ShieldCheckIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const ShieldCheck = /* @__PURE__ */ createIcon(ShieldCheckIcon, 'ShieldCheck');
